/**
 * 连续充值
 */

import { request } from '@/utils/request';

/** 连续充值查询接口 */
export const getContinueRecharge = () =>
  request({
    url: '/gamer/continuepay_query',
    method: 'GET'
  });

/** 连续充值流水百一奖金领取 */
export const receiveFlowing = level =>
  request({
    url: '/gamer/continuepay_flow_receive',
    method: 'POST',
    data: { level }
  });

/** 连续充值60倍领取*/
export const receiveMultiple = level =>
  request({
    url: '/gamer/continuepay_multie_receive',
    method: 'POST',
    data: { level }
  });
